import React from 'react';
import AppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';
import IconButton from '@mui/material/IconButton';
import Typography from '@mui/material/Typography';
import CloseIcon from '@mui/icons-material/Close';
import { blue_pilu, white_pilu } from '../../../helpers/utils';

export const NotificationsAppBar = ({
	title = 'Notificaciones',
	handleClose = null,
	pendingNotifications = 0,
}) => {
	return (
		<AppBar position='static' style={{ backgroundColor: blue_pilu }}>
			<Toolbar>
				<IconButton
					edge='start'
					style={{ color: white_pilu }}
					onClick={handleClose}
					aria-label='close'
				>
					<CloseIcon />
				</IconButton>
				<Typography
					variant='h6'
					noWrap
					component='div'
					sx={{
						color: white_pilu,
						flexGrow: 1,
						display: { xs: 'none', sm: 'block' },
						ml: 2,
					}}
				>
					{title}{' '}
					{pendingNotifications > 0 &&
						`- Pendientes: ${pendingNotifications}`}
				</Typography>
			</Toolbar>
		</AppBar>
	);
};
